module.exports = __webpack_public_path__ + "img/function-image-printer.7b308626.svg";